<template>
    <!-- 用户票券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'userTicket')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="用户票券号">
                    <a-input placeholder="请输入" v-decorator="['userTicketNo']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="票券类型">
                    <a-select allowClear placeholder="请选择" v-decorator="['type']" @select="search(false)">
                        <a-select-option value="1">期限卡</a-select-option>
                        <a-select-option value="2">次卡</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="购买门店">
                    <a-select allowClear placeholder="请选择" v-decorator="['shopId']" @select="search(false)">
                        <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="购买途径">
                    <a-select allowClear placeholder="请选择" v-decorator="['platform']" @select="search(false)">
                        <template v-for="(item,index) in $utils.platform">
                            <a-select-option :key="index" :value="index" v-if="item">{{item}}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="票券状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['ticketState']" @select="search(false)">
                        <!-- <a-select-option value="1">未生效</a-select-option> -->
                        <a-select-option value="2">已生效</a-select-option>
                        <a-select-option value="3">次数用完</a-select-option>
                        <a-select-option value="4">已过期</a-select-option>
                        <a-select-option value="5">已失效</a-select-option>
                        <a-select-option value="6">已锁定</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="票券名称">
                    <a-input placeholder="请输入" v-decorator="['ticketName']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="剩余使用次数">
                    <a-input-group compact >
                        <a-input class="range-input range-input-left" placeholder="最小剩余次数" v-decorator="['minRemainNum']" />
                        <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-input class="range-input range-input-right" placeholder="最大剩余次数" v-decorator="['maxRemainNum']" />
                    </a-input-group>
                </a-form-item>
                <a-form-item label="发放时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['payTime']"
                        @change="search(false)"
                    />
                </a-form-item>
                <a-form-item label="禁用状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['isForbidden']" @select="search(false)">
                        <a-select-option :value="0">未禁用</a-select-option>
                        <a-select-option :value="1">已禁用</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="冻结状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['isFrozen']" @select="search(false)">
                        <a-select-option :value="0">未冻结</a-select-option>
                        <a-select-option :value="1">已冻结</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button :loading="searchLoading" @click="search(false)" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-card :bordered="false">
            <template slot="extra" v-if="getBtnByAuth('exportUser')">
                <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                <a-button @click="openExportModal">导出记录</a-button>
            </template>
            <a-table :scroll="{y: 560}" bordered :loading="searchLoading" :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.userTicketNo">
                <span slot="type" slot-scope="type">{{['','期限卡','次卡','套餐票'][type]}}</span>
                <span slot="remainNum" slot-scope="a, row">{{!row.remainNum ? 0 : row.remainNum === -1 ? "不限次" : row.remainNum}}</span>
                <span slot="vailEndTime" slot-scope="a, row">{{row.vailEndTime && row.vailEndTime.substr(0,10)}}</span>
                <span slot="payTime" slot-scope="payTime">{{payTime ? payTime : "-"}}</span>
                <span slot="invalidType" slot-scope="invalidType">{{$utils.uselessState[Number(invalidType)]}}</span>
                <span slot="isForbidden" slot-scope="isForbidden">{{['未禁用','已禁用'][Number(isForbidden)]}}</span>
                <span slot="isFrozen" slot-scope="isFrozen">{{['未冻结','已冻结'][Number(isFrozen)]}}</span>
                <span slot="action" slot-scope="a, row">
                    <span v-if="row.isActivity && row.activityId">
                        <a class="text-primary" @click="onClickGiveTicket(row.userTicketNo)">赠品</a>
                        <a-divider type="vertical"/>
                    </span>
                    <span v-if="getBtnByAuth('usingDetailUser')">
                        <span v-if="row.state == 1 || row.state == 2" class="text-disabled">使用详情</span>
                        <router-link v-else class="text-primary" :to="{name:'usingDetailUser', query: {userTicketId: row.userTicketNo}}">使用详情</router-link>
                        <a-divider type="vertical"/>
                    </span>

                    <span v-if="getBtnByAuth('operateRecord')">
                        <span v-if="row.state == 1 || row.state == 2" class="text-disabled">操作记录</span>
                        <router-link v-else class="text-primary" :to="{name:'operateRecord', query: {userTicketId: row.userTicketNo}}">操作记录</router-link>
                        <a-divider type="vertical"/>
                    </span>

                    <span v-if="getBtnByAuth('amendTicket')">
                        <span v-if="row.state == 1 || row.state == 2 || row.state == 6 || row.state == 7" class="text-disabled">票券信息更改</span>
                        <router-link v-else class="text-primary" :to="{name:'amendTicketUser', query: {id: row.userTicketNo, orderId: row.orderNo}}">票券信息更改</router-link>
                        <a-divider type="vertical"/>
                    </span>
                    <template v-if="getBtnByAuth('ticketCourseState')">
                        <a class="text-primary" v-if="row.isForbidden" @click="forbidden(row.userTicketNo, false)">取消禁用</a>
                        <a class="text-primary" v-else-if="!row.isForbidden" @click="forbidden(row.userTicketNo, true)">禁用</a>
                        <span v-else class="text-disabled">禁用</span>
                    </template>
                </span>
            </a-table>
        </a-card>
        <member-order-forbidden ref="forbiddenModal" @ok="getList"></member-order-forbidden>
        <report-export-modal ref="reportExportModal" :exportType="4"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import memberOrderForbidden from '@/components/modules/order/member-order-forbidden.component'
    const columns = [
    {
        title: "用户票券号",
        dataIndex: "userTicketNo"
    },
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "票券内部标识",
        dataIndex: "name"
    },
    {
        title: "票券展示名称",
        dataIndex: "showName"
    },
    {
        title: "票券类型",
        dataIndex: "type",
        scopedSlots: { customRender: "type" }
    },
    {
        title: "票券状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "失效类型",
        dataIndex: "invalidType",
        scopedSlots: { customRender: "invalidType" }
    },
    {
        title: "禁用状态",
        dataIndex: "isForbidden",
        scopedSlots: { customRender: "isForbidden" }
    },
    {
        title: "冻结状态",
        dataIndex: "isFrozen",
        scopedSlots: { customRender: "isFrozen" }
    },
    {
        title: "票券剩余次数",
        dataIndex: "remainNum",
        scopedSlots: { customRender: "remainNum" }
    },
    {
        title: "有效期",
        dataIndex: "vailEndTime",
        scopedSlots: { customRender: "vailEndTime" }
    },
    {
        title: "发放时间",
        dataIndex: "grantTime",
        scopedSlots: { customRender: "grantTime" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    import moment  from 'moment';
    export default {
        name: "userTicket",
        components: {
            memberOrderForbidden
        },
        props: {},
        data() {
            return {
                options: [],
                columns,
                dataSource: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                phoneList: [],
                searchLoading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            onClickGiveTicket(id) {
                this.$router.push({name: "sendDetail", query: {id: id}, params: {orderId: 0}})
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.pagination.pageSize = 20
                this.pagination.current = 1
                this.form.resetFields();
                this.getList()
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        return;
                    }
                });
            },

            // 获取购票订单列表
            getList(isExport) {
                if (this.searchLoading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.minGrantTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.maxGrantTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined

                    let shopId = values.shopId || this.shopId;

                    delete values.payTime
                    this.searchLoading = true;
                    this.loading = true;

                    this.$api.order.userTicketSearch({
                        query: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            // shopId: (values.phone && !values.shopId) || shopId == -1 ? undefined : shopId + ",-1",
                        })
                    }).then(res => {
                        this.searchLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        if (isExport) {
                            this.exportExcel();
                        } else {
                            this.loading = false;
                        }
                    }).catch(err => {
                        this.searchLoading = false;
                        this.loading = false;
                    });
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.minGrantTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.maxGrantTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined
                    delete values.payTime
                    this.loading = true
                    this.$api.order.orderSearchExport({
                        query: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: this.pagination.total
                        })
                    })
                    .then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
            /**
             * @forbidden 禁用/解禁
             */
            forbidden(userTicketId, forbidden) {
                this.$refs.forbiddenModal.show(userTicketId, forbidden);
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        created() {},
        mounted() {
            setTimeout(() => {
                this.getShopList()
                this.getList()
            }, 500);
        },
        watch: {
            '$route'(val) {
                val.name == 'userTicket' && this.getList();
            },
            'shopId'(val) {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>